// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, number, object } from 'prop-types'
import { makeModulationSchemeLabel } from 'redux/helpers'

const ModulationRow = props => {
  const {
    enabled,
    engineeringReferenceFlag,
    modulationScheme,
    throughput,
    txPowerMax,
  } = props

  const modulationSchemeDescription = makeModulationSchemeLabel(modulationScheme)
  const engRef = engineeringReferenceFlag ? '*' : ''
  const modThuText = `${engRef}${modulationSchemeDescription} / ${throughput}`

  return (
    <tr className={enabled ? 'active' : 'inactive'}>
      <td title={modThuText}>
        {modThuText}
      </td>
      <td title={txPowerMax}>
        {txPowerMax}
      </td>
    </tr>
  )
}

ModulationRow.propTypes = {
  enabled: bool.isRequired,
  engineeringReferenceFlag: bool,
  modulationScheme: object,
  throughput: number,
  txPowerMax: number.isRequired,
}

export default ModulationRow
